import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './spinner.html',
  styleUrl: './spinner.css',
})
export class Spinner {
  constructor(public loader: LoaderService) {}

}
